<template>
  <div>
    <DpplSubMenu
      v-if="(subMenuOptions || []).length"
      v-bind="$props"
      :sub-menu-options="subMenuOptions"
      :selected-option="selectedOption"
      :disabled="subMenuDisabled"
      :chip-height="chipHeight"
      chip-color="white"
      :is-pill="false"
      :margin="false"
      :should-open-on-hover="false"
      prepend-icon="material-symbols:sort"
      @submit-sub-menu="submit({ optionId: $event, router: $router })"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'pinia';
import DpplSubMenu from '@/components/datapeople/DpplSubMenu.vue';
import { useFilters } from '@/stores/filters/filters';
import { useSubMenu } from '@/stores/filters/subMenu';

export default {
  name: 'FilterSubMenu',
  components: {
    DpplSubMenu,
  },
  props: {
    type: { default: null, type: String },
    loading: { default: false, type: Boolean },
    chipHeight: { type: Number, default: 32 },
  },
  emits: ['filters-tracking-event'],
  computed: {
    ...mapState(useSubMenu, ['subMenuOptions', 'subMenuDisabled', 'selectedOption']),
  },
  methods: {
    ...mapActions(useFilters, ['submitSubMenu']),
    submit({ optionId, router }) {
      const selected = this.subMenuOptions.find((option) => option.id === optionId);
      this.$emit('filters-tracking-event', {
        action: 'filterSubMenuClick',
        args: { option: selected.value },
      });
      this.submitSubMenu({ optionId, router });
    },
  },
};
</script>
